export const journeyCopyDa = {
    profileCompleteTitle: "Profil fuldført",
    profileCompleteStatusLabel: "Profil gemt",
    profileCompleteConsentDescription: "Dine profiloplysninger er gemt. Næste trin gennemgår vi samtykke.",
    profileCompleteSetupDescription:
        "Dine profiloplysninger er gemt. Næste trin skal vi bruge dine behandlingsoplysninger.",
    profileCompleteFormsDescription: "Dine profiloplysninger er gemt. Næste trin kan du udfylde dine formularer.",
    profileCompleteDiaryDescription: "Dine profiloplysninger er gemt.",
    consentCompleteTitle: "Samtykke fuldført",
    consentCompleteStatusLabel: "Samtykke underskrevet",
    consentCompleteSetupDescription:
        "Dine samtykkevalg er registreret. Nu skal vi bare bruge dine behandlingsoplysninger.",
    consentCompleteFormsDescription: "Dine samtykkevalg er registreret. Næste trin kan du udfylde dine formularer.",
    consentCompleteDiaryDescription: "Dine samtykkevalg er registreret.",
    setupCompleteTitle: "Opsætning fuldført",
    setupCompleteStatusLabel: "Opsætning gemt",
    setupCompleteConsentDescription: "Næste trin gennemgår vi samtykke.",
    setupCompleteFormsDescription:
        "Dine behandlingsoplysninger er klar. Næste trin kan du udfylde dine første formularer.",
    setupCompleteDiaryDescription: "Dine behandlingsoplysninger er klar.",
    goToConsent: "Gå til samtykke",
    goToSetup: "Gå til opsætning",
    knowProcedureDateYetTitle: "Kender du datoen endnu?",
    knowProcedureDateYetMessage:
        "Tilføj din proceduredato, når du kender den, så opfølgningsspørgsmålene matcher din behandling.",
    addProcedureDate: "Tilføj proceduredato",
    addHospitalNumber: "Tilføj hospitalsnummer",
    addSide: "Tilføj side",
    addEventDate: (eventPhrase) => `Tilføj dato for ${eventPhrase}`,
    reviewConsent: "Gennemgå samtykke",
    shortcutsHeading: "Mangler stadig:",
    goToForms: "Gå til formularer",
    goToYourDiary: "Gå til din dagbog",
    goToYourResults: "Gå til dine resultater",
    seeCharts: "Se diagrammer",
    formCompleteTitle: "Formular fuldført",
    formCompleteNextDescription: "Dit svar er gemt. Du kan fortsætte til næste indtastning.",
    formCompleteAllDoneDescription: "Dit svar er gemt. Du er ajour for nu. Du kan se dine resultater.",
    formCompleteAllCaughtUpTitle: "Alt er ajour",
    formCompleteAllCaughtUpNextDue: (date) => `Næste forfalder ${date}`,
    formCompleteNextEntryDue: (scheduleLabel, date) =>
        `Din ${scheduleLabel.toLowerCase()}-indtastning er forfalden den ${date}.`,
    formCompleteStatusSuffix: "fuldført",
    continueToNextForm: "Næste",
    phaseProfile: "Profil",
    phaseSetup: "Opsætning",
    phaseConsent: "Samtykke",
    phaseForms: "Formularer",
    phaseDiary: "Dagbog",
    setupHospitalNumber: "Hospitalsnummer",
    setupProcedureDate: "Proceduredato",
    setupSide: "Side",
    loadingProgress: "Indlæser fremskridt...",
    progressTitle: "Din fremgang",
    dismissProgress: "Luk fremgang",
    currentStage: "Aktuelt trin",
    stepProgressAriaLabel: (stepLabel) => `Fremgang: ${stepLabel}`,
    stepOf: "af",
    nextStep: "Næste trin",
    formsDoneCount: (done, total) => `Udfyldte skemaer: ${done} af ${total}`,
    diaryStillSettingUp: "Din dagbog er ved at blive oprettet. Det kan tage et øjeblik.",
    tryAgain: "Prøv igen",
};
